import { useTabs } from '../../../../../hooks/useTabs';
import { SheetTabs } from '../../../../spreadsheet/components/SheetTabs';
import FanGainGGDataSpreadsheet from './FanGainGGDataSpreadsheet';
import FanGainGGDifferencesSpreadsheet from './FanGainGGDifferencesSpreadsheet';
import FanGainRevenueSpreadsheet from './FanGainRevenueSpreadsheet';

interface FanGainGGSpreadsheetProps {
  defaultMonth: number;
  defaultYear: number;
}

type TabType = 'data' | 'differences' | 'revenue';

export function FanGainGGSpreadsheet({ defaultMonth, defaultYear }: FanGainGGSpreadsheetProps) {
  const { activeTab, handleTabChange } = useTabs<TabType>('data');

  const tabs = [
    { id: 'data', label: 'GG Data' },
    { id: 'differences', label: 'Differences' },
    { id: 'revenue', label: 'Revenue'}
  ];

  return (
    <div className="space-y-0">
      {activeTab === 'data' && (
        <FanGainGGDataSpreadsheet
          defaultMonth={defaultMonth}
          defaultYear={defaultYear}
        />
      )}

      {activeTab === 'differences' && (
        <FanGainGGDifferencesSpreadsheet
          defaultMonth={defaultMonth}
          defaultYear={defaultYear}
        />
      )}

      {activeTab === 'revenue' && (
        <FanGainRevenueSpreadsheet
          defaultMonth={defaultMonth}
          defaultYear={defaultYear}
        />
      )}

      <SheetTabs
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />
    </div>
  );
}

export default FanGainGGSpreadsheet;